import type { PresetListing } from "@pax/api-contract/presets/v1alpha1";
import { cn, focusHaloFlush, panelMotion, press } from "@pax/ui";
import { Link } from "@tanstack/react-router";
import { largestSource, srcSet } from "@/lib/images";

/** A scenario's cover over its title and the two facts that tell scenarios apart at a glance. */
export function PresetCard({ listing, className }: { listing: PresetListing; className?: string }) {
  return (
    <Link
      to="/presets/$slug"
      params={{ slug: listing.slug }}
      className={cn(
        "rounded-2xl text-left hover:opacity-80",
        panelMotion,
        press,
        focusHaloFlush,
        className,
      )}
    >
      <img
        src={listing.cover ? largestSource(listing.cover) : undefined}
        srcSet={listing.cover ? srcSet(listing.cover) : undefined}
        alt=""
        loading="lazy"
        decoding="async"
        className="aspect-[16/10] w-full rounded-2xl bg-foreground/5 object-cover ring-1 ring-foreground/10"
      />
      <span className="mt-2 block truncate text-sm font-medium">{listing.title}</span>
      <span className="block truncate text-xs text-muted-foreground">
        {listing.startDate} &middot; {listing.entityCount.toLocaleString()} map entities
      </span>
    </Link>
  );
}
